import { Component, OnInit, Inject } from '@angular/core';
import { VERSION, MatDialogRef, MatDialog, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { NewLinePipe } from '../../../../../core/_base/layout/pipes/new-line.pipe';
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { FunctionsUtilsService } from '../../../../../core/_base/crud/utils/functions-utils.service';

export interface DialogData {
  title?: string;
  message?: string;
  waitMessage?: string;
  type?: string;
  icon?: string;
  url?: string;
  urlText?: string;
  cancelBtnText?: string;
  confirmBtnText?: string;
  hasAction?: boolean;
  customSize ?: boolean;
  action?: () => {};
  duration?: 2500;
}

@Component({
  selector: 'app-informative-dialog',
  templateUrl: './informative-dialog.component.html',
  styleUrls: ['./informative-dialog.component.scss'],
  providers: [NewLinePipe]
})
export class InformativeDialogComponent implements OnInit {
  	// Public properties
	viewLoading: boolean = false;
  constructor(private route: ActivatedRoute,
    private router: Router,
    public functionsUtilsService:FunctionsUtilsService,
    public dialogRef: MatDialogRef<InformativeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {

    if (data == undefined || data == null) {
      data = {};
    }

    if (data.type == undefined) {
      data.type = 'success';
    }

    if (data.hasAction == undefined) {
      data.hasAction = false;
    }

  }

  ngOnInit() {
    let dialogWidth = 26;
    let dialogHeight = 'auto';

    if (this.data.hasAction || this.data.type == 'confirm') {
    //  dialogHeight -= 1.5;
    } 
    if(!this.data.customSize)
    this.dialogRef.updateSize(`${dialogWidth}pc`, `${dialogHeight}`);

    if(this.data.duration){
      setTimeout(() => {
         this.onNoClick();
      }, this.data.duration);
    }
  }

	/**
	 * Close dialog with false result
	 */
	onNoClick(): void {
		this.dialogRef.close();
	}

	/**
	 * Close dialog with true result
	 */
	onYesClick(): void {
		/* Server loading imitation. Remove this */
		this.viewLoading = true;
		setTimeout(() => {
			this.dialogRef.close(true); // Keep only this row
		}, 500);
  }

  onCompleteClick(){
    this.dialogRef.close(2); // Keep only this row
  }

}
